<template>
  <div class="table-body">
    <slot />
  </div>
</template>
<script>
import { ContainerMixin } from "vue-slicksort";

export default {
  name: "VoucherTemplatesList",

  mixins: [ContainerMixin],

  props: ["item"]
};
</script>
